// Script to focus the company logo as soon as possible
(function() {
  // Function to focus the company logo
  function focusLogo() {
    var companyLogos = document.querySelectorAll('.company-logo-link');
    if (companyLogos.length > 0) {
      // Force focus on the first company logo
      companyLogos[0].focus();
    }
  }
  
  // Function to restore tabindex values for icons
  function restoreTabIndex() {
    var cartIcons = document.querySelectorAll('.icons--cart-icon-button');
    var searchIcons = document.querySelectorAll('.icons--search-icon-button');
    
    // Restore cart icons
    cartIcons.forEach(function(icon) {
      icon.setAttribute('tabindex', '0');
      icon.removeAttribute('aria-hidden');
    });
    
    // Restore search icons
    searchIcons.forEach(function(icon) {
      icon.setAttribute('tabindex', '0');
    });
  }
  
  // Run focus logo immediately
  focusLogo();
  
  // Also run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      focusLogo();
      // Restore tabindex after a delay to ensure logo gets focus first
      setTimeout(restoreTabIndex, 1000);
    });
  } else {
    focusLogo();
    // Restore tabindex after a delay to ensure logo gets focus first
    setTimeout(restoreTabIndex, 1000);
  }
  
  // Run when window loads
  window.addEventListener('load', function() {
    focusLogo();
    // Restore tabindex after a delay to ensure logo gets focus first
    setTimeout(restoreTabIndex, 1000);
  });
})();
